// @ts-nocheck
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import { DEFAULT_ANSWERS, DEFAULT_DATA } from './data/liveDemoData';
import { LoginA, LoginB } from './screens/LoginScreens';
import { Assessment, DashboardHandoff, Intake, Prep } from './screens/FlowScreens';
import { upsertLiveDemoLead } from './services/leadApi';

const DRAFT_KEY = 'admissionsAssuredLiveDemoDraft';
const LEAD_KEY = 'admissionsAssuredLiveDemoLead';

const readDraft = () => {
  try {
    return JSON.parse(sessionStorage.getItem(DRAFT_KEY) || 'null');
  } catch {
    return null;
  }
};

export default function LiveDemoApp({ onOpenDashboard }) {
  const authData = useAuth();
  const draft = readDraft();
  const [screen, setScreen] = useState(draft?.screen || "A");
  const [data, setData] = useState(draft?.data || DEFAULT_DATA);
  const [answers, setAnswers] = useState(draft?.answers || DEFAULT_ANSWERS);
  const [previewGroup, setPreviewGroup] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  useEffect(() => {
    sessionStorage.setItem(DRAFT_KEY, JSON.stringify({ screen, data, answers }));
  }, [screen, data, answers]);

  const go = (nextScreen) => {
    setScreen(nextScreen);
  };

  const submitLead = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    setSubmitError('');
    try {
      const lead = await upsertLiveDemoLead(data, authData);
      sessionStorage.setItem(LEAD_KEY, JSON.stringify(lead));
      go('prep');
    } catch (error) {
      setSubmitError(error?.response?.data?.message || error?.message || 'Unable to submit the lead. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const restart = () => {
    sessionStorage.removeItem(DRAFT_KEY);
    sessionStorage.removeItem(LEAD_KEY);
    setData(DEFAULT_DATA);
    setAnswers(DEFAULT_ANSWERS);
    setPreviewGroup(null);
    setSubmitError('');
    go('A');
  };

  const openDashboard = () => {
    sessionStorage.removeItem(DRAFT_KEY);
    sessionStorage.removeItem(LEAD_KEY);
    onOpenDashboard();
  };

  let view;
  if (screen === "A") view = <LoginA onProceed={() => go("intake")} />;
  else if (screen === "B") view = <LoginB onProceed={() => go("intake")} />;
  else if (screen === "intake") view = <Intake data={data} setData={setData} onProceed={() => go("assessment")} />;
  else if (screen === "assessment") {
    view = (
      <Assessment
        data={data}
        answers={answers}
        setAnswers={setAnswers}
        previewGroup={previewGroup}
        setPreviewGroup={setPreviewGroup}
        onComplete={submitLead}
        isSubmitting={isSubmitting}
        submitError={submitError}
      />
    );
  } else if (screen === "prep") view = <Prep data={data} answers={answers} onOpen={openDashboard} />;
  else view = <DashboardHandoff data={data} onRestart={restart} />;

  return (
    <div className="app">
      {view}
    </div>
  );
}
